import * as PIXI from "pixi.js";
import MiddleLayer from "../../layers/MiddleLayer";
import Grid from "../grid/Grid";
import TextureManager from "../../managers/TextureManager";
import { EventBus, EnumEventBus } from "../../managers/EventBus";
import { fireworkObject } from "../../types/Config";
import ExplosionAnimation from "../../animations/ExplosionAnimation";
import WinningIcon from "../WinningIcon";
import Firework from "./FireworkController";

export default class Explosion {
  private MiddleLayer = MiddleLayer.getInstance();
  private Grid = Grid.getInstance();
  private EventBus = EventBus;
  private Firework:Firework;
  constructor(Firework:Firework){
    this.Firework = Firework;;
  }
  run() {
    const colorName = this.Firework.wIconIndex > -1 ? fireworkObject[this.Firework.index].color : "empty";
    const alpha = colorName == "empty" ? 0 : 1;
    let texture = TextureManager.getTexture(this.Firework.generateAssetsPath(colorName));
    this.Firework.hideFirework()

    const explosionSpr = new PIXI.Sprite(texture);
    explosionSpr.x = this.Firework.x;
    explosionSpr.y = this.Firework.y;
    explosionSpr.anchor.set(.5);
    explosionSpr.width = 169 * .3;
    explosionSpr.height = 153 * .3;
    this.MiddleLayer.addChild(explosionSpr);

    new ExplosionAnimation(explosionSpr, 169 * .9, 153 * .9, alpha, () => {
      explosionSpr.parent.removeChild(explosionSpr);
      explosionSpr.destroy();

      if (this.Firework.wIconIndex > -1) {
        const WFwElm = this.Grid.winningFireworks.find(e => e.firework == this.Firework);
        if (WFwElm === undefined) { return }
        const WIcon = new WinningIcon(this.Firework.wIconIndex, this.Firework.x, this.Firework.y);
        const WEIndex = this.Grid.winningFireworks.indexOf(WFwElm);
        const gridCoord = this.Firework.getGridCoord();
        this.Grid.winningFireworks.splice(WEIndex, 1);
        if (this.Grid.winningFireworks.length == 0) {
          this.Grid.setTotalWon();
          this.EventBus.emit(EnumEventBus.gameIsCompleted);
        }
        setTimeout(() => this.Firework.remove(), 1000);
        this.Grid.grid[Number(gridCoord.c)][Number(gridCoord.r)] = WIcon;
      }
    });
  }
}